import Jersey from '../Jersey/Jersey';
import MissingPlayers from '../MissingPlayers/MissingPlayers';

interface JerseyWithMissingPlayersProps {
  /** URL of the jersey image. */
  jerseySrc: string;
  /** List of missing player names shown below the jersey. */
  missingPlayers?: string[];
  /** Localized label passed through to MissingPlayers. */
  missingPlayersLabel: string;
}

export default function JerseyWithMissingPlayers({
  jerseySrc,
  missingPlayers = [],
  missingPlayersLabel,
}: JerseyWithMissingPlayersProps) {
  return (
    <div className="flex flex-col items-center min-w-0">
      <Jersey jerseySrc={jerseySrc} size={82} withOverlay />
      {missingPlayers.length > 0 && (
        <MissingPlayers
          label={missingPlayersLabel}
          players={missingPlayers}
          className="mt-[-18px] z-10"
        />
      )}
    </div>
  );
}
